export interface RequestInvitationBody {
  firstName?: string;
  lastName?: string;
  company?: string;
  email?: string;
  message?: string;
}

export interface UserRegistrationRequest {
  username?: string;
  firstName?: string;
  lastName?: string;
  jobTitle?: string;
  company_name?: string | null;
  company_id?: string | null;
  company?: string;
  email?: string;
  phone?: string;
  password?: string;
  rePassword?: string;
  message?: string | null;
  termsAndConditionsAgree?: boolean;
  sso?: boolean;
}

export interface AuthRedirectQueryParams {
  registration?: string;
  username?: string;
  password?: string;
  sso?: boolean;
  inactive?: boolean;
  token?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
}

export enum ActivationStatus {
  ACTIVE_COMPLETED = 'ACTIVE_COMPLETED',
  NOT_ACTIVE = 'NOT_ACTIVE',
  PENDING_INPROGRESS = 'PENDING_INPROGRESS',
  ON_HOLD = 'ON_HOLD',
  AWAITING = 'AWAITING',
  SUBSCRIBER = 'SUBSCRIBER',
  TMP = 'TMP',
}
